import React from 'react';
import { Link } from 'react-router-dom';
import { mockListings } from '../services/mockData';

const FeaturedListings = () => {
  const listings = Object.values(mockListings);

  return (
    <section className="featured-section">
      <div className="container">
        <h2>Featured Repair Services</h2>
        <p>Connect with trusted repair companies in your area</p>
        <div className="listings-grid">
          {listings.map((listing) => (
            <Link key={listing.id} to={`/listing/${listing.id}`} className="listing-card">
              <div className="listing-image">
                <img src={listing.mainImage} alt={listing.name} />
                <div className="listing-rating">
                  <span className="rating-star">★</span>
                  <span className="rating-number">{listing.rating}</span>
                  <span className="rating-count">({listing.reviewCount})</span>
                </div>
              </div>
              <div className="listing-content">
                <h3>{listing.name}</h3>
                <p className="listing-description">{listing.description}</p>
                <div className="listing-location">
                  <span className="location-icon">📍</span>
                  {listing.address}
                </div>
                <div className="listing-services">
                  {listing.services.slice(0, 3).map((service, index) => (
                    <span key={index} className="service-tag">
                      {service}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedListings;
